import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,{staticClass:"pl-3 pr-2",attrs:{"align":"center"}},[_c(VCol,{staticClass:"pa-1 subtitle-2 font-weight-bold",attrs:{"cols":"12","sm":"4","md":"3","lg":"3"}},[_vm._t("header")],2),_c(VCol,{staticClass:"pa-1"},[_vm._t("data")],2),(_vm.border)?_c(VCol,{staticClass:"pa-0",attrs:{"cols":"12"}},[_c(VDivider)],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }